import RemoveAuthKeysModal from './RemoveAuthKeysModal';

export default RemoveAuthKeysModal;